type DropInPaymentOptionsLike = {
  single_price?: unknown | null;
  single_total?: unknown | null;
  campaign?: unknown | null;
  single_requires_payment_method: boolean;
  single_visit_available: boolean;
  active_memberships?: readonly unknown[];
  active_packages?: readonly unknown[];
};

export function isFreeDropInAdmission(
  options: DropInPaymentOptionsLike,
): boolean {
  return (
    options.single_price !== null &&
    options.single_price !== undefined &&
    options.single_visit_available &&
    options.single_requires_payment_method === false
  );
}

/**
 * A free drop-in rate supersedes every entitlement path. Normalize once at
 * each API boundary so rendering, selection validation, and submission all see
 * the same one-action contract even if a stale mixed response reaches a client.
 */
export function canonicalizeDropInPaymentOptions<
  T extends DropInPaymentOptionsLike,
>(options: T): T {
  if (!isFreeDropInAdmission(options)) return options;
  return {
    ...options,
    active_memberships: [],
    active_packages: [],
  } as T;
}
